module.exports = __webpack_public_path__ + "static/media/29DUNON12.70159de7.jpg";